import React, { useEffect, useState } from "react";
import {
  getInputName,
  getMsisdn,
  getUserToken,
  setMsisdn,
} from "../utils/global";

import styles from "./OTP.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import TiktokPixel from "tiktok-pixel";
import axios from "axios";
//toast notifictions
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//
import {
  Login,
  Register,
  login,
  otpVerification,
  fetchOtp,
  requestStatus,
} from "../services/client-login-service";
import { userSession } from "../services/client-login-service";
import { imgname } from "../services/images";
import OTPInput from "react-otp-input";
import { error } from "jquery";

const OTP = () => {
  const [otp, setOtp] = useState("");
  const [isChargedToday, setIsChargedToday] = useState(null); // Initialize with null
  const [isHe, setHe] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const currentTime = new Date().getTime();
  const [loading, setLoading] = useState(false);
  var count = 0;
  var alreadyregister = 0;
  var otpSent = 0;
  var otpError = "";
  var checkcharged = 0;
  //
  //

  //
  //
  //

  useEffect(() => {
    TiktokPixel.init("CNE39KBC77UCVTJIS4D0");
    const fetchData = async () => {
      const accessToken = localStorage.getItem("access_token");
      const storedMsisdn = localStorage.getItem("no-msisdn");
      try {
        const response = await axios.get(
          `https://dcb.noeticworld.com/sgw/user/otp-verification/is-msisdn-charged-today/${storedMsisdn}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        checkcharged = response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
      let body2 = {
        msisdn: localStorage.getItem("no-msisdn"),
      };

      if (checkcharged == "1") {
        await Register(body2).then((data) => {
          localStorage.setItem("jwt_j", data["token"]);
          localStorage.setItem("loginTime",currentTime)
          Login(localStorage.getItem("jwt_j")).then(
            (Response) => {
              window.location.href = Response["url"];

              const msisdn_payload = {
                msisdn: localStorage.getItem("no-msisdn"),
              };
            },
            (err) => {}
          );
        });
      }
    };

    fetchData();

    const session = {
      userSessionId: localStorage.getItem("UserSessionId"),
      sessionType: "OTPPage",
    };
    userSession(session).then(
      (userSessionResponse) => {},
      (userSessionError) => {
        console.log(userSessionError);
      }
    );

    const no_msisdn = localStorage.getItem("no-msisdn");
    let body =
      "msisdn=" +
      no_msisdn +
      "&trackerId=" +
      localStorage.getItem("TRACKER_ID") +
      "&otp=true";
    otpVerification(body).then(
      (otpVerificationResponse) => {
        if (localStorage.getItem("PARTNER_NAME") == "tiktok" && otpSent === 0) {
          otpSent = 1;

          TiktokPixel.track("OTP sent successful", {
            content_type: "games",
            content_id: getMsisdn(),
            currency: "PKR",
            value: 10,
          });
          window.fbq("track", "ButtonClicked");
        }

        //   setTimeout(() => {
        //     fetchOtp(no_msisdn).then(fetchOtpResponse => {
        //     	// if (localStorage.getItem('HeCase') == true) {
        //     		setTimeout(() => {
        //     			document.getElementById('OTP').value = fetchOtpResponse;
        //     		}, 3000)
        //     	// }
        //     })
        //   }
        // );

        setTimeout(() => {
          const Track = localStorage.getItem("msisdn");

          const tsring = Track ? Track.toString() : "";

          // Check if the value is found in localStorage
          if (tsring === "not_found") {
            // alert("Value found in localStorage");

            // Break the operation after the alert
            return;
          }

          // Continue the operation if the value is not "HE"
          fetchOtp(no_msisdn)
            .then((fetchOtpResponse) => {
              let otpValue =
                typeof fetchOtpResponse === "number"
                  ? fetchOtpResponse.toString()
                  : fetchOtpResponse;

              if (otpValue.length === 4 && /^\d+$/.test(otpValue)) {
                // Set the OTP in the state
                setOtp(fetchOtpResponse);
              } else {
                // console.error("Fetched OTP is not 4 digits:", fetchOtpResponse);
              }
            })
            .catch((error) => {
              console.error("Error fetching OTP:", error);
            });
        }, 1000);
      },
      (otpVerificationError) => {
        console.error(otpVerificationError);
      },
      1000
    );
  }, []);

  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  function generateString(length) {
    let result = " ";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
  }

  const jwtString = generateString(32);

  const getRandomIndices = (array, count) => {
    const shuffled = array.sort(() => Math.random() - 0.5);
    return shuffled.slice(0, count);
  };

  const [randomIndices, setRandomIndices] = useState(
    getRandomIndices(imgname, 5)
  );

  const [timer, setTimer] = useState(5 * 60);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((time) => time - 1);
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    if (timer === 0) {
      window.location.reload();
    }
  }, [timer]);

  const onCLickSubscribe = (otp) => {
    if (otp == "") {
      toast.info("Please enter the valid 4 Digit OTP");
      return 0;
    }

    if (localStorage.getItem("no-msisdn") == "923208648637" && otp === "1234") {
      localStorage.setItem("jwt_j", "gT23bsdvsSACS128");
      localStorage.setItem("loginTime",currentTime)

      window.location.href = "/home";
    }
    setLoading(true);

    window.dataLayer.push({
      event: "pageview",
      page: {
        url:
          document.location.origin +
          document.location.pathname +
          document.location.search,
        title: "OTP",
      },
    });

    // otp = (atob(otp))/99;
    const no_msisdn = localStorage.getItem("no-msisdn");
    var userAgentRecord = window.navigator.userAgent;
    var cursorRecord = true;
    setMsisdn(no_msisdn);

    const requestBody = {
      msisdn: no_msisdn,
      userAgentLogs: userAgentRecord,
      cursorRecord: cursorRecord,
    };

    axios
      .post(
        "https://useragentservice.mmsdp.com/api/create-user-agent-record",
        requestBody
      )
      .then((response) => {})
      .catch((error) => {
        console.error("User Agent Api Error: ", error);
      });
    const regex_otp_validation = /[0-9][0-9][0-9][0-9]/;
    if (regex_otp_validation.exec(otp) == null) {
      alert("Please Enter your OTP");
      setLoading(false);
      return;
    }
    if (regex_otp_validation.exec(otp) != null) {
      var tracker = localStorage.getItem("TRACKER_ID");
      if (localStorage.getItem("TRACKER_ID") == "null") {
        tracker = "noetic tracker";
      }
      let body =
        "msisdn=" +
        getMsisdn() +
        "&trackerId=" +
        tracker +
        "&otp=true" +
        "&otpNumber=" +
        otp;

      login(body).then(
        async (loginResponse) => {
          const maxAttempts = 120;
          try {
            // await sleep(12000);
            for (let i = 0; i < maxAttempts; i++) {
              const requestStatusResponse = await requestStatus(
                loginResponse["correlationId"]
              );
              await sleep(1000);
              await switchfunction(requestStatusResponse);
              count++;
            }
          } catch (error) {
            console.log(error);
          }

          function sleep(ms) {
            return new Promise((resolve) => setTimeout(resolve, ms));
          }

          async function switchfunction(requestStatusResponse) {
            switch (requestStatusResponse["code"]) {
              // 105 - Request in Progress
              case "105": {
                if (count == 120) {
                  // clearInterval(requestStatu);
                  //   isLoaderHidden = true;
                  setLoading(false);
                  window.location.reload();
                }

                break;
              }

              // 110 - Valid User ( Already Subscribed )
              case "110": {
                let body2 = {
                  msisdn: getMsisdn(),
                };
                Register(body2).then((data) => {
                  localStorage.setItem("jwt_j", data["token"]);
                  localStorage.setItem("loginTime",currentTime)
                  Login(localStorage.getItem("jwt_j")).then(
                    (Response) => {
                      window.location.href = "/home";

                      // console.log(res);
                    },
                    (err) => {}
                  );
                });
                // clearInterval(requestStatu);
                // console.log(this.userToken);
                localStorage.setItem("no-msisdn", getMsisdn());
                break;
              }

              // 120 - Invalid/Incorrect OTP
              case "120": {
                if (
                  localStorage.getItem("PARTNER_NAME") == "tiktok" &&
                  alreadyregister == 0
                ) {
                  alreadyregister = 1;

                  TiktokPixel.track("Incorrect OTP", {
                    content_type: "games",
                    content_id: getMsisdn(),
                    currency: "PKR",
                    value: 10,
                  });
                  window.fbq("track", "ButtonClicked");
                }
                // clearInterval(requestStatu);
                //   isLoaderHidden = true;
                //   isButtonHidden = false;

                toast.error(
                  `Invalid User !\nThe OTP you have entered is incorrect`
                );

                setLoading(false);
                window.location.reload();
                // this.otp = '';
                // this.router.navigateByUrl('');
                break;
              }

              // 118 - Valid User ( Already Subscribed ) Valid User
              case "118": {
                let body2 = {
                  msisdn: getMsisdn(),
                };
                Register(body2).then((data) => {
                  localStorage.setItem("jwt_j", data["token"]);
                  localStorage.setItem("loginTime",currentTime)
                  Login(localStorage.getItem("jwt_j")).then(
                    (Response) => {
                      console.log(Response["url"]);
                      const msisdn_payload = {
                        msisdn: localStorage.getItem("no-msisdn"),
                      };
                      window.location.href = "/home";
                    },
                    (err) => {}
                  );
                });
                // clearInterval(requestStatu);

                localStorage.setItem("no-msisdn", getMsisdn());
                break;
              }

              // 119 - Invalid User ( Blocked User )

              case "119": {
                toast.error(
                  `You have been Blocked from using this service\nPlease contact Jazz Support Centre`
                );
                navigate("");
                break;
              }

              // 116 - Postpaid User
              case "116": {
                toast.error(
                  "Unauthorized User !\nThis service is only for Jazz Prepaid users"
                );
                setLoading(false);
                // window.location.reload();
                navigate("/login");
                break;
              }

              // 122 - Insufficient Balance
              case "122": {
                if (
                  localStorage.getItem("PARTNER_NAME") == "tiktok" &&
                  alreadyregister == 0
                ) {
                  alreadyregister = 1;

                  TiktokPixel.track("Subscribe", {
                    content_type: "games",
                    content_id: getMsisdn(),
                    currency: "PKR",
                    value: 10,
                  });

                  window.fbq("track", "ButtonClicked");
                }
                let body2 = {
                  msisdn: getMsisdn(),
                };
                await Register(body2).then((registerResponse) => {
                  localStorage.setItem("jwt_j", registerResponse["token"]);
                  localStorage.setItem("loginTime",currentTime)
                  toast.success(
                    "Successfully Subscribed !\nYou will be charged Rs.10.0/day after 1 day free trial."
                  );

                  Login(localStorage.getItem("jwt_j")).then(
                    (res) => {
                      window.location.href = res["url"];
                      const msisdn_payload = {
                        msisdn: localStorage.getItem("no-msisdn"),
                      };
                    },
                    (err) => {}
                  );
                });
                // clearInterval(requestStatu);

                localStorage.setItem("no-msisdn", getMsisdn());

                break;
              }

              //101 - Subscribed Successfully , Balance Deducted
              case "101": {
                if (
                  localStorage.getItem("PARTNER_NAME") == "tiktok" &&
                  alreadyregister == 0
                ) {
                  alreadyregister = 1;

                  TiktokPixel.track("Subscribe", {
                    content_type: "games",
                    content_id: getMsisdn(),
                    currency: "PKR",
                    value: 10,
                  });

                  window.fbq("track", "ButtonClicked");
                }
                let body2 = {
                  msisdn: localStorage.getItem("no-msisdn"),
                };
                await Register(body2).then((data) => {
                  toast.success(`Successfully Subscribed !`);
                  localStorage.setItem("jwt_j", data["token"]);
                  localStorage.setItem("loginTime",currentTime)
                  Login(localStorage.getItem("jwt_j")).then(
                    (res) => {
                      const user = {
                        msisdn: localStorage.getItem("no-msisdn"),
                        avatarId: 1,
                      };
                      window.location.href = res["url"];
                    },
                    (err) => {}
                  );
                });
                // clearInterval(requestStatu);

                //   this.conversion()
                localStorage.setItem("no-msisdn", getMsisdn());
                break;
              }

              //115 - Unauthorized - Not a Jazz User
              case "115": {
                // clearInterval(requestStatu);
                //   this.isLoaderHidden = true;

                toast.error(
                  "Unauthorized User !\nThis service is only for Jazz Prepaid users"
                );
                setLoading(false);
                // window.location.reload();
                navigate("/login");
                break;
              }
            }
          }

          // Call handleRequestStatus initially
        },
        (loginError) => {
          console.error(loginError);
        }
      );
    }
  };

  return (
    <div className={styles.LoginpageContainer}>
      <button className={styles.backButton} onClick={() => navigate(-1)}>
        <img
          src="https://cdn-icons-png.flaticon.com/128/271/271220.png"
          alt=""
        />
      </button>
      <ToastContainer />

      <div className={styles.LogoBox}>
        <img src="assets/images/logo (1).png" className={styles.Logo} />
      </div>

      <div className={styles.Welcome}>
        <h2 className="title">
          Welcome to
          <br />
          GAMENOW
        </h2>
      </div>

      <div className={styles.ForMContainer}>
        <label htmlFor="Code">Enter subscription code</label>
        <OTPInput
          inputType="number"
          value={otp}
          onChange={setOtp}
          id="OTP"
          numInputs={4}
          renderSeparator={<span>-</span>}
          renderInput={(props) => (
            <input
              {...props}
              type="tel"
              style={{
                width: "50px",
                height: "50px",
                textAlign: "center",
                border: "none",
                outline: "none",
                borderRadius: "5px",
                margin: "2px",
                padding: "5px",
              }}
            />
          )}
        />
        <span className={styles.OTP_TIME}>
          {" "}
          Resend Code After: {Math.floor(timer / 60)}:
          {timer % 60 < 10 ? "0" : ""}
          {timer % 60}
        </span>

        <button
          id="OTPButton"
          type="submit"
          className={styles.LoginButton}
          onClick={() => onCLickSubscribe(otp)}
          disbaled={loading}
        >
          {loading ? <span>Loading..</span> : "SUBSCRIBE"}
        </button>
      </div>

      <div className={styles.LoginTermsANdConditions}>
        <strong className={styles.TANC_TEXT}>
          Only For Jazz Prepaid Customers
        </strong>

        <strong className={styles.TANC_TEXT}>
          You will be charged up to Rs. 10/day, including tax.
        </strong>
      </div>
    </div>
  );
};
export default OTP;
